import type { InventoryItemOutcome } from "@redotech/crdb-enums/inventory/inventory-item-outcome";
import { useRequiredContext } from "@redotech/react-util/context";
import { useLoad } from "@redotech/react-util/load";
import { returnsCenterIdFormat } from "@redotech/redo-warehouse-id";
import { RedoAdminRpcClientContext } from "../../../app/redo-admin-rpc-client-provider";

/** Each listed center's supported outcomes, keyed by decoded id; a center that fails to load is left out. */
export function useReturnsCentersSupportedOutcomes(
  returnsCenterIds: readonly string[],
): ReadonlyMap<string, readonly InventoryItemOutcome[]> | undefined {
  const client = useRequiredContext(RedoAdminRpcClientContext);
  const key = returnsCenterIds.join(",");
  return useLoad(async () => {
    const ids = key === "" ? [] : key.split(",");
    const results = await Promise.allSettled(
      ids.map((id) =>
        client.getReturnsCenterSupportedOutcomes({
          returnsCenterId: returnsCenterIdFormat.write(BigInt(id)),
        }),
      ),
    );
    return new Map(
      ids.flatMap((id, index) => {
        const result = results[index];
        return result?.status === "fulfilled"
          ? [[id, result.value.supportedOutcomes] as const]
          : [];
      }),
    );
  }, [client, key]).value;
}
